import { Button, Modal, ModalBody, ModalFooter, ModalHeaderWithTitle } from '@zoom/components';
import React from 'react';

interface ModalConfirmationProps {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  headerText: string;
  bodyText: string | JSX.Element;
  submitText: string;
  closeText: string;
}

export const ModalConfirmation = ({
  bodyText,
  headerText,
  onClose,
  onSubmit,
  show,
  submitText,
  closeText,
}: ModalConfirmationProps) => (
  <Modal show={show} onClose={onClose} settings={{ locale: { rtl: 'en' } }}>
    <ModalHeaderWithTitle onClose={onClose}>{headerText}</ModalHeaderWithTitle>
    <ModalBody>{bodyText}</ModalBody>
    <ModalFooter className="justify-content-end">
      <Button kind="secondary" onClick={onSubmit}>
        {submitText}
      </Button>
      <Button kind="link" onClick={onClose}>
        {closeText}
      </Button>
    </ModalFooter>
  </Modal>
);
